import axios from "axios";
import { IAuthPayload } from "../interfaces/auth";

export interface IAuth {
    authEndpoint: string;
    verifyEndpoint: string;
    logoutEndpoint: string;

    auth: (payload: IAuthPayload) => Promise<AuthResult>;
    verify: (token: string, wallet: string) => Promise<boolean>
    logout: (sessionId: number) => Promise<void>
}

interface AuthResult {
    ok: boolean;
    token: string;
}

export class Auth implements IAuth {
    authEndpoint: string;
    verifyEndpoint: string;
    logoutEndpoint: string;

    constructor(apiGateway: string) {
        if (!apiGateway) {
            apiGateway = 'https://auth.kattana.trade';
        }
        this.authEndpoint = `${apiGateway}/auth`;
        this.verifyEndpoint = `${apiGateway}/verify`;
        this.logoutEndpoint = `${apiGateway}/logout`;
    }

    public auth = async (payload: IAuthPayload): Promise<AuthResult> => {
        try {
            const { data } = await axios.post(this.authEndpoint, payload);
          
            return {
                ok: true,
                token: data
            };
          } catch (error) {
            console.warn(error);
            return {
                ok: false,
                token: ''
            };
          }
    }

    public verify = async (token: string, wallet: string): Promise<boolean> => {
        try {
            const { data } = await axios.get(this.verifyEndpoint, {
                params: {
                    wallet,
                    token
                }
            });
    
            return data;
        } catch (error) {
            console.warn(error);
            return false;
        }
    }

    public logout = async (sessionId: number): Promise<void> => {
        try {
            const { data } = await axios.delete(this.logoutEndpoint, {
                params: {
                    session_id: sessionId
                }
            });
    
            return data;
        } catch (error) {
            console.warn(error);
            return;
        }
    }
}